import { cart } from '@/api'
import Store from '@/constants/store'
import ToastType from '@/constants/toast-type'
import { toast } from '@/composables/toast'

export const useCartStore = defineStore(Store.CART, {
    state: () => ({
        items: [],
        subtotal: 0.00,
        taxes: 0.00,
        total: 0.00,
        amount: 0.00,
        credit: 0.00,
        debit: 0.00,
        available: 0.00,
        scheduled: 0.00,
        payments: 1,
        override: 0,
        waiting: 0,
        full: 0,
        orderData: [] // Not synched, only available after checkout
    }),

    getters: {
        order: (state) => state.orderData
    },

    actions: {
        sync (data) {
            this.items = data.items
            this.subtotal = data.subtotal
            this.taxes = data.taxes
            this.total = data.total
            this.amount = data.amount
            this.credit = data.credit
            this.debit = data.debit
            this.available = data.available
            this.scheduled = data.scheduled
            this.payments = data.payments
            this.override = data.override
            this.waiting = data.waiting
            this.full = data.full
        },

        async refresh () {
            const response = await cart.show()

            this.sync(response.data)
        },

        async add (payload) {
            const response = await cart.add(payload)

            this.sync(response.data)
        },

        async update (payload) {
            const response = await cart.update(payload)

            this.sync(response.data)
        },

        async remove (key) {
            const response = await cart.remove(key)

            this.sync(response.data)
        },

        async removeOption (key, option) {
            const response = await cart.removeOption(key, option)

            this.sync(response.data)
        },

        async setPayments (number) {
            const response = await cart.payments(number)

            this.sync(response.data)
        },

        async setOverride (number) {
            const response = await cart.override(number)

            this.sync(response.data)
        },

        /**
         * Create the order for the cart items.
         *
         * @return {Promise<boolean>} Whether the order was created.
         */
        async checkout () {
            return await cart.checkout({ items: this.items }).then(response => {
                const { data } = response?.data
                this.orderData = data

                return true
            }).catch(error => {
                if (error.response?.status !== 422 && error.response?.data?.message) {
                    toast(ToastType.ERROR, error.response.data.message, 3500)
                }

                return false
            })
        }
    }
})
